/**
 * Centralized production configuration.
 *
 * All environment-specific values are read from Vite environment variables
 * (prefixed with VITE_) with sensible defaults for development and production.
 *
 * To override defaults, set the corresponding VITE_ variable in `.env.local`
 * or in your deployment environment (e.g., Cloudflare Pages build settings).
 *
 * @example
 * ```
 * VITE_DEFAULT_CASHU_MINT_URL=https://my-mint.example.com
 * VITE_DEFAULT_CASHU_MINT_LABEL=My Mint
 * VITE_EVOLU_SYNC_URL=wss://my-evolu-relay.example.com
 * ```
 *
 * @module lib/config
 */

/**
 * Application configuration object.
 *
 * All values come from VITE_ environment variables with hardcoded fallbacks.
 * The fallbacks are the production defaults -- no .env file is required for
 * the app to work out of the box.
 */
export const CONFIG = {
  /**
   * Default Cashu mint URL for new wallets and restore fallback.
   *
   * Override: `VITE_DEFAULT_CASHU_MINT_URL`
   */
  defaultMintUrl:
    import.meta.env.VITE_DEFAULT_CASHU_MINT_URL || 'https://mint.minibits.cash/Bitcoin',

  /**
   * Human-readable label for the default Cashu mint.
   *
   * Override: `VITE_DEFAULT_CASHU_MINT_LABEL`
   */
  defaultMintLabel: import.meta.env.VITE_DEFAULT_CASHU_MINT_LABEL || 'Minibits',

  /**
   * Evolu CRDT sync relay URL.
   *
   * Override: `VITE_EVOLU_SYNC_URL`
   */
  evoluSyncUrl: import.meta.env.VITE_EVOLU_SYNC_URL || 'wss://free.evoluhq.com',
} as const;
